import React, { useState } from "react";

const defaultFaqs = [
  {
    q: "7 दिन के free trial के बाद क्या होगा?",
    a: "Trial खत्म होने पर app की सारी सुविधाएँ lock हो जाती हैं। फिर ₹99/month या ₹599/year में subscribe करके सब कुछ unlock कर सकते हैं। Trial में कोई payment नहीं — credit card की भी ज़रूरत नहीं।",
  },
  {
    q: "कौन से बोर्ड cover हैं?",
    a: "BSEB (बिहार), UPMSP (UP), JAC (झारखंड), MPBSE (MP), RBSE (राजस्थान), CGBSE (छत्तीसगढ़), UBSE (उत्तराखंड), HBSE (हरियाणा), HPBOSE (हिमाचल), CBSE, NCERT — कुल 25+ boards. Class 6 से 12 तक।",
  },
  {
    q: "क्या Hindi medium में पढ़ाई होगी?",
    a: "हाँ। App का default language हिंदी है। हर subject में Hindi और English दोनों में content मिलता है — आपकी पसंद का।",
  },
  {
    q: "Kunji AI क्या है? क्या trial में मिलेगा?",
    a: "Kunji AI एक doubt-solver है — सवाल की तस्वीर खींचो, AI step-by-step solution देता है। साथ में revision, practice, और pre-board test भी हैं। Trial के 7 दिनों में सब कुछ unlocked मिलता है, उसके बाद paid plan में।",
  },
  {
    q: "क्या offline use कर सकते हैं?",
    a: "हाँ। Videos, notes, और test papers download करके बिना internet के पढ़ाई कर सकते हैं — बस wifi/data पर एक बार download कर लीजिए।",
  },
  {
    q: "कौन से devices support हैं?",
    a: "अभी app Android phones पर Google Play Store से available है। Tablets पर भी चलता है।",
  },
  {
    q: "Payment कैसे करना है?",
    a: "Subscription पूरी तरह in-app होती है — Paytm secure gateway के through UPI, debit/credit card, या net banking से payment कर सकते हैं।",
  },
  {
    q: "क्या refund policy है?",
    a: "7 दिन का free trial इसी लिए है — पसंद आए तभी पैसे लगाएं। Subscription एक बार activate हो जाने पर non-refundable है (technical issues छोड़कर)। Details: schooglink.com/returns।",
  },
];

const FAQ = ({ faqs = defaultFaqs }) => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" aria-label="Frequently asked questions" className="py-14 px-4 bg-gray-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-8">
          अक्सर पूछे जाने वाले सवाल
        </h2>
        <div className="divide-y divide-gray-200 bg-white rounded-2xl border border-gray-200 overflow-hidden">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  aria-controls={`faq-panel-${i}`}
                  className="w-full text-left px-5 py-4 flex justify-between items-center hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-gray-900">{f.q}</span>
                  <span
                    aria-hidden
                    className={`ml-4 text-blue-600 text-xl select-none transition-transform ${
                      open ? "rotate-45" : ""
                    }`}
                  >
                    +
                  </span>
                </button>
                {open && (
                  <div
                    id={`faq-panel-${i}`}
                    className="px-5 pb-5 text-gray-700 leading-relaxed"
                  >
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
